angular.module('homebot.directives')

  .directive('cmaQuestions', ['DataService', 'UtilService', 'Dictionary',
    function(DataService, utils, Dictionary){
    return {
      restrict: 'A',
      controllerAs: 'questionsCtrl',
      bindToController: {
        home: '=',
        userId: '@',
        onComplete: '&',
        hasRecentlyRequested: '&'
      },
      scope: {},
      templateUrl: '/homes/templates/partials/cma-questions.html',

      controller: function(){
        var ctrl = this;
        let dictionary = new Dictionary();

        ctrl.step = ctrl.hasRecentlyRequested() ? 1 : 0;
        ctrl.skipped = false;
        ctrl.agent = ctrl.home.agent[0];
        ctrl.answers = ctrl.home.answers;
        ctrl.homeFacts = {
          bedrooms: ctrl.home.bedrooms,
          bathrooms: ctrl.home.bathrooms,
          finishedSqFt: ctrl.home.finishedSqFt,
        };

        if(ctrl.agent.type !== 'realestate' && dictionary.sellingAgent(ctrl.home))
          ctrl.previousRea = dictionary.sellingAgent(ctrl.home);

        ctrl.nextQuestion = function(step){
          ctrl.step = step || Math.floor(ctrl.step + 1);
        };

        ctrl.finishQuestions = function(){
          ctrl.onComplete({
            requestedCma: !ctrl.skipped,
          });
          utils.track('CMARequestFinished');
        };

        ctrl.requestCma = function(cmaBuyersAgentPreferred){
          // TODO: This will be combined into one call on the api
          DataService
            .saveCMARequest(ctrl.home.id, cmaBuyersAgentPreferred)
            .then(() => {
              return DataService.trackHome({
                  source:'user',
                  event:'cma-request',
                  homeId:ctrl.home.id,
                  userId:ctrl.userId,
                  agentId:ctrl.agent.id,
                  isEstimateCorrect:ctrl.answers.isEstimateCorrect,
                });
            })
            .then(() => {
              ctrl.home.hasRequestedCMA = moment().toDate();
            })
            .catch((e) => {
              utils.trackException('Save CMA Request', e);
              console.error(e);
            });

          utils.track('CMARequest');
          ctrl.nextQuestion();
        };

        ctrl.skipCmaRequest = function(){
          utils.track('CMARequestSkipped');
          ctrl.skipped = true;
          ctrl.nextQuestion();
        };

        ctrl.setAnswer = function(question, answer){
          answer = answer.constructor === 'string' ? answer.trim() : answer;

          utils.track('CMAQuestionAnswered', question);

          ctrl.answers[question] = answer;

          DataService.saveAnswer(question, answer, ctrl.home.id).catch(function(err){
            utils.trackException('Save Answer', err);
          });
        };

        ctrl.saveHomeUpdatedDescription = function(){
          let answer = ctrl.answers.homeUpdatedDescription ?
            ctrl.answers.homeUpdatedDescription.trim() : null;

          if(answer)
            ctrl.setAnswer('homeUpdatedDescription', answer);
        };
      }
    }

  }]);
